import { Coords } from 'google-map-react';

export const COUNTRY_NAMES = {
  CANADA: 'Canada',
  USA: 'United States',
};

export enum Region {
  US_AUSTIN = 'us-austin',
  US_SOUTH_TEXAS = 'us-south-texas',
  US_DALLAS_FORT_WORTH = 'us-dallas-fort-worth',
  US_HOUSTON = 'us-houston',
  US_JACKSONVILLE = 'us-jacksonville',
  US_LOS_ANGELES = 'us-los-angeles',
  US_MIAMI = 'us-miami',
  US_ORLANDO = 'us-orlando',
  US_SAN_ANTONIO = 'us-san-antonio',
  US_SAN_FRANCISCO = 'us-san-francisco',
  US_TAMPA = 'us-tampa',
  CA_CALGARY = 'ca-calgary',
  CA_EDMONTON = 'ca-edmonton',
  CA_TORONTO = 'ca-toronto',
  CA_VANCOUVER = 'ca-vancouver',
  US_INDIANAPOLIS = 'us-indianapolis',
}

export enum State {
  TX = 'TX',
  FL = 'FL',
  IN = 'IN',
}

export const METROPOLITAN_CODE_TO_STATE_CODE: { [key: string]: string } = {
  'us-austin': 'TX',
  'us-south-texas': 'TX',
  'us-dallas-fort-worth': 'TX',
  'us-san-antonio': 'TX',
  'us-houston': 'TX',
  'us-jacksonville': 'FL',
  'us-miami': 'FL',
  'us-orlando': 'FL',
  'us-tampa': 'FL',
  'us-indianapolis': 'IN',
};

export const METROPOLITAN_CODE_TO_LABEL: { [key: string]: string } = {
  'us-austin': 'Austin',
  'us-south-texas': 'South Texas',
  'us-dallas-fort-worth': 'Dallas/Fort Worth',
  'us-houston': 'Houston',
  'us-jacksonville': 'North Florida',
  'us-los-angeles': 'Los Angeles',
  'us-miami': 'Gold Coast & South',
  'us-orlando': 'Central Florida',
  'us-san-antonio': 'San Antonio',
  'us-indianapolis': 'Indianapolis',
  'us-san-francisco': 'San Francisco',
  'us-tampa': 'Gulf Coast',
  'ca-calgary': 'Calgary',
  'ca-edmonton': 'Edmonton',
  'ca-toronto': 'Toronto',
  'ca-vancouver': 'Vancouver',
};

export const STATE_CODE_TO_LABEL: { [key: string]: string } = {
  TX: 'Texas',
  FL: 'Florida',
  IN: 'Indiana',
};

/* TEMPORARY HACK: Used in company search filters where we want to limit the
 * options to only texas. This will be removed once we launch florida.
 */
export const METROPOLITAN_CODE_TO_LABEL_FOR_COMPANY_SEARCH: { [key: string]: string } = {
  'us-austin': 'Austin',
  'us-south-texas': 'South Texas',
  'us-dallas-fort-worth': 'Dallas/Fort Worth',
  'us-houston': 'Houston',
  'us-jacksonville': 'North Florida',
  'us-miami': 'Gold Coast & South',
  'us-orlando': 'Central Florida',
  'us-san-antonio': 'San Antonio',
  'us-indianapolis': 'Indianapolis',
  'us-tampa': 'Gulf Coast',
};

export const STATE_DEFAULT_COORDINATES: { [key: string]: Coords } = {
  [State.TX]: {
    lat: 31.260355,
    lng: -96.725784,
  },
  [State.FL]: {
    lat: 28.642187,
    lng: -81.10958,
  },
  [State.IN]: {
    lat: 39.7797845,
    lng: -86.13275,
  },
};

export const REGION_DEFAULT_COORDINATES: { [key in Region]: Coords } = {
  [Region.US_AUSTIN]: {
    lat: 30.311836,
    lng: -97.731033,
  },
  [Region.US_SOUTH_TEXAS]: {
    lat: 30.311836,
    lng: -97.731033,
  },
  [Region.US_DALLAS_FORT_WORTH]: {
    lat: 32.7767,
    lng: -96.797,
  },
  [Region.US_HOUSTON]: {
    lat: 29.910978,
    lng: -95.636806,
  },
  [Region.US_JACKSONVILLE]: {
    lat: 30.274665,
    lng: -81.807708,
  },
  [Region.US_LOS_ANGELES]: {
    lat: 34.05334,
    lng: -118.24235,
  },
  [Region.US_MIAMI]: {
    lat: 25.969086,
    lng: -80.302542,
  },
  [Region.US_ORLANDO]: {
    lat: 28.665217,
    lng: -81.500052,
  },
  [Region.US_SAN_ANTONIO]: {
    lat: 29.406513,
    lng: -98.64514,
  },
  [Region.US_INDIANAPOLIS]: {
    lat: 39.7797845,
    lng: -86.13275,
  },
  [Region.US_SAN_FRANCISCO]: {
    lat: 37.756677,
    lng: -122.439489,
  },
  [Region.US_TAMPA]: {
    lat: 27.944603,
    lng: -82.414664,
  },
  [Region.CA_CALGARY]: {
    lat: 51.0447,
    lng: -114.0719,
  },
  [Region.CA_TORONTO]: {
    lat: 43.6532,
    lng: -79.3832,
  },
  [Region.CA_EDMONTON]: {
    lat: 53.546059,
    lng: -113.493712,
  },
  [Region.CA_VANCOUVER]: {
    lat: 49.246292,
    lng: -123.116226,
  },
};

export const isValidRegion = (regionQuery: string) => {
  return Object.values(Region).includes(regionQuery as Region);
};
